<template>
  <div class="video-container-wrapper">
    <div class="video-container">
      <iframe width="100%" height="100%" :src="vacancyVideo" frameborder="0" allow="autoplay; encrypted-media" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vacancyVideo: String
  }
}
</script>

<style lang="scss" scoped>

  .video-container-wrapper {
    width: 100%;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .video-container {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
    margin-bottom: 40px;
    display: inline-table;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>
